import workforce from './widgets/workforce';
import chronicConditions from './widgets/ChronicConditions';
import absenteeism from './widgets/Absenteeism';
import healthOfficeVisits from './widgets/HealthOfficeVisits';

export default [workforce, chronicConditions, absenteeism, healthOfficeVisits];
